import { IBarrierCode } from '@interfaces/task/barrier'

type TMockedBarrierCode = IBarrierCode

export const mockedBarrierCodes: TMockedBarrierCode[] = [
  {
    description: 'S.01 - Schedule incorrectly allocated',
    isActive: true,
    id: 209,
  },
  {
    description: 'E.18 - Eng. Resource Unavailable',
    isActive: true,
    id: 210,
  },
  {
    description: 'E.17 - Equipment not in Shop',
    isActive: true,
    id: 211,
  },
  {
    description: 'E.07 - Process equipment unavailable',
    isActive: true,
    id: 212,
  },
  {
    description: 'S.03 - 3 month Supply/Demand Change',
    isActive: true,
    id: 213,
  },
  {
    description: 'E.12 - Maintenance resources unavailable',
    isActive: true,
    id: 214,
  },
  {
    description: 'E.14 - Technical resource unavailable',
    isActive: true,
    id: 215,
  },
  {
    description: 'E.15 - Mech. Driven Ahead of Sch.',
    isActive: true,
    id: 216,
  },
  {
    description: 'E.13 - Operations resources unavailable',
    isActive: true,
    id: 217,
  },
  {
    description: 'P.09 - Drawings incorrect',
    isActive: true,
    id: 218,
  },
  {
    description: 'P.08 - Job plan not sufficient',
    isActive: true,
    id: 219,
  },
  {
    description: 'S.02 - Job added to 1 month Sch.',
    isActive: true,
    id: 220,
  },
  {
    description: 'E.04 - Motorized equipment unavailable',
    isActive: true,
    id: 221,
  },
  {
    description: 'Waiting on Gas Test',
    isActive: false,
    id: 222,
  },
  {
    description: 'E.03 - Material unavailable',
    isActive: true,
    id: 223,
  },
  {
    description: 'O.01 - Weather',
    isActive: true,
    id: 225,
  },
  {
    description: 'S.04 - 4 Week Production Change',
    isActive: true,
    id: 226,
  },
  {
    description: 'E.20 - Offsite Resource Delay',
    isActive: true,
    id: 227,
  },
  {
    description: 'Waiting On Permit Greater Than 30 mins.',
    isActive: false,
    id: 228,
  },
  {
    description: 'E.05 - Tools unavailable',
    isActive: true,
    id: 229,
  },
  {
    description: 'E.01 - Workgroup productivity',
    isActive: true,
    id: 230,
  },
  {
    description: 'P.04 - Tools incorrect',
    isActive: true,
    id: 231,
  },
  {
    description: 'P.03 - Material not ordered',
    isActive: true,
    id: 232,
  },
  {
    description: 'P.05 - Process planning inadequate',
    isActive: true,
    id: 233,
  },
  {
    description: 'P.02 - Material incorrect',
    isActive: true,
    id: 234,
  },
  {
    description: 'E.09 - Unit upset',
    isActive: true,
    id: 235,
  },
  {
    description: 'E.08 - Production schedule change',
    isActive: true,
    id: 236,
  },
  {
    description: 'P.07 - Work scope insufficient',
    isActive: true,
    id: 237,
  },
  {
    description: 'P.06 - Pre Job preparation not completed',
    isActive: true,
    id: 238,
  },
  {
    description: 'E.11 - Working Break-ins',
    isActive: true,
    id: 239,
  },
  {
    description: 'E.10 - Scope Change/Expansion',
    isActive: true,
    id: 240,
  },
  {
    description: 'Weather',
    isActive: false,
    id: 241,
  },
  {
    description: 'P.10 - Technical documentation not available',
    isActive: true,
    id: 242,
  },
  {
    description: 'P.11 - Fabrication error - offsite',
    isActive: true,
    id: 243,
  },
  {
    description: 'P.12 - Allocated resource hours incorrect',
    isActive: true,
    id: 244,
  },
  {
    description: 'P.13 - Safety considerations / concerns',
    isActive: true,
    id: 245,
  },
  {
    description: 'Work Site Preparation LTA',
    isActive: false,
    id: 246,
  },
  {
    description: 'E.19 - Insp. Resource Unavailable',
    isActive: true,
    id: 247,
  },
  {
    description: 'P.01 - Motorized equipment incorrect',
    isActive: true,
    id: 248,
  },
  {
    description: 'E.16 - Oper. Driven ahead of Sch.',
    isActive: true,
    id: 249,
  },
  {
    description: 'E.06 - Permit not available',
    isActive: true,
    id: 250,
  },
  {
    description: 'E.02 - Fabrication error - onsite',
    isActive: true,
    id: 251,
  },
]
